const IsUsingTmobCms = () => {
  return process.env.REACT_APP_USE_TMOB_CMS === 'true' || false;
};

export default IsUsingTmobCms;
